export const ja = {
    translation: {
        b: {
            cancel: 'キャンセル',
            confirm: '確認',
            send: '送信',
            done: '完了',
            close: '閉じる',
            clear: 'クリア',
            copy_link: 'リンクをコピー',
            export: 'エクスポート',
            delete: '削除',
            delete_confirm: '削除の確認',
            duplicate: '複製',
            share: '共有',
            sign_in: 'ログイン',
            sign_up: '新規登録',
            email_address: 'メールアドレス',
            yes: 'はい',
            no: 'いいえ'
        },
        m_languages: {
            title: '言語',
            subtitle: '言語を選択'
        },
        m_feedback: {
            feature: {
                name: '機能リクエスト',
                desc: '必要な機能が見つかりませんか？ぜひお知らせください — あなたのアイデアは重要です'
            },
            feedback: {
                name: 'フィードバック',
                desc: '皆さまのフィードバックは私たちにとって非常に大切です — ひと言だけでもお寄せください'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'ご提案ありがとうございます！',
                desc: 'ご意見を共有いただきありがとうございます。製品改善の大きな助けになります。'
            },
            feedback: {
                name: 'フィードバックありがとうございます！',
                desc: 'ご意見を共有いただきありがとうございます。製品改善の大きな助けになります。'
            }
        },
        m_diagram_details: {
            name_place: 'プロジェクト名を入力',
            desc_place: 'プロジェクトの説明を入力'
        },
        m_quick_share: {
            title: 'クイック共有',
            subtitle: '(クエリベースのリンク共有)'
        },
        m_export_img: {
            title: '画像をエクスポート'
        },
        m_export_code: {
            title: 'コード {{db_engine}} をエクスポート',
            download_file: 'ファイルをダウンロード',
            copy_code: 'コードをコピー'
        },
        m_sign_in_remind: {
            title: '作業を続けるにはサインイン', // ?
            subtitle: 'ログインまたは新規登録すると、テーブル数上限の拡張、ダイアグラムの保存、その他の機能をご利用いただけます。'
        },
        m_sign_in_restrict: {
            title: 'アプリでさらに作業するにはサインイン', // アプリでさらに作業するにはログイン
            subtitle: 'ログインまたは新規登録して、テーブル上限を増やし、ダイアグラムを保存し、追加機能を利用しましょう。'
        },
        m_new_diagram: {
            title: '新規ダイアグラム',
            subtitle: 'データベースエンジンを選択',
            open_diagram: 'ダイアグラムを開く'
        },
        m_keyboard_shortcuts: {
            title: 'キーボードショートカット',
            ctrl_left: {
                title1: 'コントロール',
                title2: '(左)',
                items: {
                    mouse_sel: 'マウス選択 / ハンドモード',
                    table: 'テーブル',
                    line: 'ライン',
                    area: 'エリア',
                    note: 'メモ',
                    comment: 'コメント',
                    pen: 'ペン',
                    undo: '元に戻す',
                    redo: 'やり直し'
                }
            },
            ctrl_top_left: {
                title1: 'コントロール',
                title2: '(左上)',
                items: {
                    export_img: '画像をエクスポート',
                    search: '検索',
                    editor_panel: 'エディターパネル'
                }
            },
            ctrl_bottom_right: {
                title1: 'コントロール',
                title2: '(右下)',
                items: {
                    minimap: 'ミニマップ',
                    zoom_in: 'ズームイン',
                    zoom_out: 'ズームアウト',
                    zoom_100: 'ズーム 100%'
                }
            },
            ctx_tab: {
                title1: 'コンテキストメニュー',
                title2: '(テーブル)',
                items: {
                    dupl_tab: 'テーブルを複製',
                    del_tab: 'テーブルを削除'
                }
            },
            ctx_del_tab: {
                title1: 'コンテキストメニュー',
                title2: '(テーブルの削除)',
                items: {
                    yes: 'はい',
                    no: 'いいえ'
                }
            },
            ctx_tab_col: {
                title1: 'コンテキストメニュー',
                title2: '(テーブル列)',
                items: {
                    add_col_below: '下に列を追加',
                    focus_col_above: '上の列にフォーカス',
                    focus_col_below: '下の列にフォーカス',
                    move_col_up: '列を上へ移動',
                    move_col_down: '列を下へ移動',
                    dupl_col: '列を複製',
                    del_col: '列を削除'
                }
            },
            ctx_line: {
                title1: 'コンテキストメニュー',
                title2: '(ライン)',
                items: {
                    del_line: 'ラインを削除'
                }
            },
            ctx_area: {
                title1: 'コンテキストメニュー',
                title2: '(エリア)',
                items: {
                    dupl_area: 'エリアを複製',
                    del_area: 'エリアを削除'
                }
            },
            ctx_multi: {
                title1: 'コンテキストメニュー',
                title2: '(複数選択)',
                items: {
                    select_all: 'すべての要素を選択',
                    create_area_for_select_els: '選択要素のエリアを作成',
                    dupl_select_els: '選択要素を複製',
                    del_select_els: '選択要素を削除'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'マウス選択',
                table: 'テーブル',
                line: 'ライン',
                area: 'エリア',
                note: 'メモ（近日公開）',
                comment: 'コメント（近日公開）',
                pen: 'ペン',
                undo: '元に戻す',
                redo: 'やり直し'
            },
            ctrl_top_left: {
                logo: '注: ここはサンドボックス（テスト用）です',
                name: 'ダイアグラム情報',
                editor: 'エディター（近日公開）',
                search: '検索（近日公開）',
                export: 'エクスポートオプション',
                view_mode: '表示モード',
                zoom_to_fit: '画面に合わせる'
            },
            ctrl_top_right: {
                feature_req: '機能リクエスト',
                sign_in: 'ログイン',
                quick_share: 'クイック共有'
            },
            ctrl_bottom_right: {
                full_screen: '全画面表示',
                minimap: 'ミニマップ',
                zoom_out: 'ズームアウト',
                zoom_100: 'ズーム 100%',
                zoom_in: 'ズームイン',
                info: '情報とリソース'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'デフォルト',
                        blue: '青',
                        green: '緑',
                        red: '赤',
                        purple: 'パープル',
                        violet: 'バイオレット'
                    },
                    borders: {
                        none: 'なし',
                        solid: '実線',
                        dashed: '破線',
                        dotted: '点線'
                    },
                    color: '色',
                    border: '枠線',
                    description: '説明',
                    description_table_place: 'テーブルの説明',
                    description_column_place: '列の説明',
                    description_line_place: 'ラインの説明',
                    description_note_place: 'メモの説明',
                    description_area_place: 'エリアの説明',
                    description_pen_place: 'ペンの説明',
                    hide_menu: 'メニューを非表示',
                    show_menu: 'メニューを表示'
                },
                tab_col: {
                    add_col_below: '下に列を追加',
                    add_col_above: '上に列を追加',
                    key: 'Key 設定',
                    keys: {
                        none: 'なし',
                        pk: 'PK (主キー)',
                        fk: 'FK (外部キー)'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'なし',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: '列を下へ移動',
                    move_col_up: '列を上へ移動',
                    more_functions: 'その他の機能'
                },
                line: {
                    change_connects: 'コネクタを変更',
                    connects: {
                        empty: 'なし',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: '要素をフィルタ'
                },
                multi: {
                    filter: '選択をフィルタ',
                    create_area: 'エリアを作成'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'すべて',
            keys_only: 'キーのみ',
            names_only: '名前のみ'
        },
        dropdown_ctrl_export: {
            export_img: '画像をエクスポート',
            export_code: 'SQL コードをエクスポート'
        },
        dropdown_ctrl_settings: {
            sign_in: 'ログイン',
            new_project: '新規プロジェクト',
            keyboard_shortcuts: 'キーボードショートカット',
            languages: '言語'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'フィードバック',
            keyboard_shortcuts: 'キーボードショートカット',
            languages: '言語',
            homepage: 'ホームページ'
        },
        n: {
            default: '読み込み中…',
            file_ready_to_download: 'ファイルのダウンロード準備ができました',
            code_copied: 'コードをコピーしました',
            link_copied: 'リンクをコピーしました',
            please_enter_message: 'メッセージを入力してください',
            invalid_email: 'メールアドレスが無効です',
            something_wrong_contact: '問題が発生しました。ページを再読み込みするか、サポートへご連絡ください。',
            something_wrong: '問題が発生しました。ページを再読み込みしてください。',
            sending: '送信中…',
            request_sent: 'リクエストを送信しました。ありがとうございます！'
        }
    }
};

export const jaMeta = {
    lang_origin: '日本語',
    lang_eng: 'Japanese',
    lang_code: 'ja',
};
